import { lazy, Suspense, useEffect } from 'react';

const AuthDialog = lazy(() => import('./AuthDialog'));
type Props = { open: boolean; onOpenChange: (open: boolean) => void; onSuccess?: () => void };

export default function LazyAuthDialog(props: Props) {
  const { open, onOpenChange } = props;
  useEffect(() => {
    if (!open) return;
    const close = (event: KeyboardEvent) => { if (event.key === 'Escape') onOpenChange(false); };
    document.addEventListener('keydown', close);
    return () => document.removeEventListener('keydown', close);
  }, [open, onOpenChange]);
  if (!open) return null;
  return <Suspense fallback={<div className="fixed inset-0 z-50 grid place-items-center bg-black/40" onClick={() => onOpenChange(false)}><div role="status" className="rounded-xl bg-white px-6 py-5 text-foreground shadow-xl">Loading sign-in…</div></div>}>
    <AuthDialog {...props} />
  </Suspense>;
}
